import React from "react";
import { FiCheck, FiClock, FiMinus, FiX } from "react-icons/fi";
import { getApprovalFlowSteps } from "./TravelExpenseApprovalUtils";

const stepStyles = {
  approved: {
    pill: "border-emerald-300 bg-emerald-500/15 text-emerald-700 dark:border-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300",
    icon: FiCheck,
  },
  rejected: {
    pill: "border-rose-300 bg-rose-500/15 text-rose-700 dark:border-rose-700 dark:bg-rose-500/10 dark:text-rose-300",
    icon: FiX,
  },
  active: {
    pill: "border-amber-300 bg-amber-500/15 text-amber-700 dark:border-amber-700 dark:bg-amber-500/10 dark:text-amber-300",
    icon: FiClock,
  },
  inactive: {
    pill: "border-slate-200 bg-slate-100 text-slate-500 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-400",
    icon: FiMinus,
  },
};

const TravelExpenseApprovalFlow = ({ item }) => {
  const steps = getApprovalFlowSteps(item);

  return (
    <div className="min-w-[180px]">
      <div className="flex items-center justify-center gap-2">
        {steps.map((step) => {
          const config = stepStyles[step.status] || stepStyles.inactive;
          const Icon = config.icon;

          return (
            <div key={step.key} className="flex flex-col items-center gap-1">
              <div
                className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-semibold ${config.pill}`}
                title={step.approver ? `${step.label} - ${step.approver}` : step.label}
              >
                <Icon size={12} />
                <span>{step.label}</span>
              </div>
              {step.approver ? (
                <div
                  className="max-w-[140px] truncate text-[10px] text-gray-500 dark:text-gray-400"
                  title={step.approver}
                >
                  {step.approver}
                </div>
              ) : null}
              {step.actedAtLabel ? (
                <div className="text-[10px] font-medium text-gray-500 dark:text-gray-400 whitespace-nowrap">
                  {step.actedAtLabel}
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TravelExpenseApprovalFlow;
